import PropTypes from 'prop-types'
import WorkflowSection from '../Section/WorkflowSection'
import '../Section/section.css'
import WorkflowButton from '../Section/WorkflowButton'
import { useTicketType } from '../../../hooks/useTicketTypeHook'


const AdditionalDocumentReturnSection = ({ lang, layoutType, taxState, onWorkflowButtonAction }) => {

    const { ticketType } = useTicketType(taxState);
    return (
        <WorkflowSection titleKey='' titleKeyProps={{ TaxYear: taxState.taxYear }} canClose={false}
            isAlternate={false} ticketType={taxState.ticket_type} hideHeader={true}>
            {taxState.additional_docs.map((docState, index) => {
                var labelProps = {
                    FirstName: docState.is_spouse ? taxState.spouse_firstName : taxState.primary_firstName,
                    FormName: lang === "fr" ? docState.document_name_fr : docState.document_name_en
                }
                // French form names are long ... :(
                if (lang === 'fr' && layoutType === 'mobile' && !docState.document_type.startsWith("POM")) {
                    labelProps.FormName = docState.document_type
                }

                var contextData = {
                    ...docState,
                    spouseFirstName: taxState.spouse_firstName,
                    primaryFirstName: taxState.primary_firstName,
                }
                return (
                    <div>
                        <WorkflowButton
                            buttonKey="additional_docs"
                            text="WorkflowPanel.additional_docs.titleWF"
                            textProps={labelProps}
                            key={"additional_docs_" + index}
                            icon="fa-edit"
                            showChevron="true"
                            ticketType={ticketType}
                            onClick={() => onWorkflowButtonAction("additional_docs", taxState.taxYear, contextData)}
                        />
                    </div>
                );
            })}
        </WorkflowSection>
    )
}

AdditionalDocumentReturnSection.propTypes = {
    lang: PropTypes.string.isRequired,
    layoutType: PropTypes.string.isRequired,
    onWorkflowButtonAction: PropTypes.func.isRequired,
    taxState: PropTypes.shape({
        taxYear: PropTypes.number.isRequired,
        coupled: PropTypes.bool.isRequired,
        primary_province: PropTypes.string,
        primary_firstName: PropTypes.string.isRequired,
        spouse_province: PropTypes.string,
        spouse_firstName: PropTypes.string,
        subTotal: PropTypes.number,
        tenderTotal: PropTypes.number
    })
}

export default AdditionalDocumentReturnSection;

